module.exports = __webpack_public_path__ + "static/media/complot.9e226b3a.mp4";